/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Severity } from '../models/Severity';

export class SeverityFilters {
  '_in'?: Array<Severity>;
  'notIn'?: Array<Severity>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "In",
      "type": "Array<Severity>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "NotIn",
      "type": "Array<Severity>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SeverityFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

